import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux"
import Slider from "react-slick"
import SliderLeftHovered from "../../../../images/left-black-arrow-3.png";
import SliderRightHovered from "../../../../images/right-black-arrow-3.png";
import ProductSlider from "./ProductSlider"
import emptySneakerImg from "../../../../images/emptysneakers2.png";
import emptyApparelImg from "../../../../images/emptyapparels.png";
import emptyHandbagImg from "../../../../images/emptyhandbags.png";
import { getCollectionList } from "../../../../actions/kafairAction"
import styled from "styled-components"
interface PreviousSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const PrevSlide = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
  left: 0px !important;
  &::before {
      content: "";
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, left: "40px !important", width: "40px", height: "40px", display: window.screen.availWidth < 640 ? "none" : "block" }}
      onClick={onClick}
    >
      <KickImage src={SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

interface NextSlider {
  className: string;
  style: Object;
  onClick: () => any;
}

const NextSlide = (props: NextSlider) => {
  const { className, style, onClick } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "";
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      right: -50px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: window.screen.availWidth < 640 ? "none" : "block", width: "40px", height: "40px" }}
      onClick={onClick}
    >
      <KickImage src={SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  swipe: true,
  prevArrow: <PrevSlide />,
  nextArrow: <NextSlide />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

interface DataCategory {
  selected: string
}

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type ProductSlider = {
  options: Array<string>;
  getCollectionList: (category: string, slug: string, payload: Object, name: string) => any;
  dataCategory: DataCategory;
  title: string;
  history: History;
  category: string;
}

const ProductSliderType2: FC<ProductSlider> = ({ options, getCollectionList, dataCategory, title, history, category }) => {

  // Product slider if collection have options

  const [selectedOption, setSelectedOption] = useState("")
  const [dataProducts, setDataProducts] = useState([])
  const [selectedSlug, setSelectedSlug] = useState("")
  const [collectionId, setCollectionId] = useState(null);

  useEffect(() => {
    
    // Render product slider based on selected option

      if(options.length > 0 && !selectedOption) {
        setSelectedOption(options[0])
      } 

      if(options.length > 0 && selectedOption) {
        let { selected } = dataCategory;

        let payload = {
          category: selected,
          availables: true,
          per_page: 11
        };
  
        let slug = selectedOption && selectedOption.replace(/" "/g, "-").toLowerCase()
        let name = selectedOption && selectedOption.replace(/" "/g, "_").toLowerCase()

        // Fetch collection list 
  
        getCollectionList(selected, slug, payload, name)
        .then(({ value }) => {
          setCollectionId(value?.data?.id ?? null)
          setSelectedSlug(slug)
          setDataProducts(value.data.products.data)
        })
        .catch(e => console.log(e))
      }
  }, [selectedOption])

  function changeOption(option: string) {
    setSelectedOption(option)
  }

  function navigate(url: string) {
    history.push(url)
  }

  // Ini mobile screen

  if (window.screen.availWidth < 480) {
    return (
      <div className="productSlider__V2">
        <div className="productSliderHeader__V2">
          <div className="productSliderHeaderOption__V2">
            {
              options && options.map((option: string, index: number) => (
                <div key={index}>
                  <h6 onClick={() => changeOption(option)} style={{ marginLeft: index <= 0 && "0px", color: option === selectedOption && "#242424" }}>{option}</h6>
                </div>
              ))
            }
          </div>
        </div>
        <div className="productSliderMain__V2">
          <ProductSlider
            dataProducts={dataProducts}
            chosenOption={selectedOption}
            navigate={navigate}
            navigateUrl={`${category}/collection/${selectedSlug}`}
            collectionId={collectionId}
          />
        </div>
      </div>
    )
  }

  // Ini desktop screen

  return (
    <div className="productSlider__V2">
      <div className="productSliderHeader__V2">
        <div className="productSliderHeaderOption__V2">
          {
            options && options.map((option: string, index: number) => (
              <div key={index}>
                <h6 onClick={() => changeOption(option)} style={{ marginLeft: index <= 0 && "0px", color: option === selectedOption && "#159953" }}>{option}</h6>
              </div>
            ))
          }
        </div>
      </div>
      <div className="productSliderMain__V2">
        {
          dataProducts.length > 0 && selectedOption && category && selectedSlug &&
          <ProductSlider
            dataProducts={dataProducts}
            activeBrowseAll
            chosenOption={selectedOption}
            navigate={navigate}
            navigateUrl={`${category}/collection/${selectedSlug}`}
            collectionId={collectionId}
          />
        }
      </div>
    </div>
  )
}

interface DataCategory {
  dataCategory: Object
}

const mapStateToProps = (state: DataCategory) => ({
  dataCategory: state.dataCategory
})

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (category: string, slug: string, payload: Object, name: string) => dispatch(getCollectionList(category, slug, payload, name)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ProductSliderType2)
